export const production = true

export const api_url_dev = "https://localhost:8000"
export const api_url_prod = "https://api.raxapps.com"


export const api_url = production ? api_url_prod : api_url_dev